import { default as CheckboxesWidget } from './CheckboxesWidget';
import { default as CheckboxWidget } from './CheckboxWidget';
import { default as CommentWidget } from './CommentWidget';
import { default as ImageWidget } from './ImageWidget';
import { default as RadioWidget } from './RadioWidget';
import { default as SelectWidget } from './SelectWidget';
import { default as SignatureWidget } from '../SignatureWidget';
import { default as TextareaWidget } from './TextareaWidget';
import { default as TextWidget } from './TextWidget';

export { default as CheckboxesWidget } from './CheckboxesWidget';
export { default as CommentWidget } from './CommentWidget';
export { default as ImageWidget } from './ImageWidget';
export { default as RadioWidget } from './RadioWidget';
export { default as SelectWidget } from './SelectWidget';
export { default as SignatureWidget } from '../SignatureWidget';
export { default as TextareaWidget } from './TextareaWidget';
export { default as TextWidget } from './TextWidget';

export const widgets = {
  CheckboxesWidget,
  CheckboxWidget,
  comment: CommentWidget,
  date: TextWidget,
  image: ImageWidget,
  RadioWidget,
  SelectWidget,
  signature: SignatureWidget,
  TextareaWidget,
  TextWidget,
};


// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/readonly/index.js